import { Tag, Tooltip } from 'antd';
import React, { useContext } from 'react';
import { AppContext } from '../../../../../AppContext';
import { LARGE_TOY_TOOLTIP_TEXT } from '../../../../../common/constants';

const BigToyIcon = () => {
  const {
    state: { isDesktop },
  } = useContext(AppContext);
  return (
    <Tooltip
      title={LARGE_TOY_TOOLTIP_TEXT}
      placement="top"
      zIndex={4}
      onClick={(e) => {
        e.stopPropagation();
      }}
      trigger={['hover']}
    >
      {!isDesktop ? <span>Yes</span> : ''}

      <Tag
        color="red"
        onClick={(e) => {
          e.stopPropagation();
        }}
        className="ml-8 mr-0 express-delivery-icon big-toy-tag"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 25 25"
          fill="none"
        >
          <path
            d="M12 4.96875V14.9062M12 17.7188V23.3438M2.15625 14.9062C1.37958 14.9062 0.75 15.5358 0.75 16.3125C0.75 17.0892 1.37958 17.7188 2.15625 17.7188M2.15625 14.9062H13.4062C13.7946 14.9062 14.1461 15.0637 14.4006 15.3181L19.6137 20.5312H21.9375C22.7142 20.5312 23.3438 21.1608 23.3438 21.9375V23.3438H19.0312C18.6429 23.3438 18.2914 23.1863 18.0369 22.9319L12.8238 17.7188H2.15625M2.15625 14.9062V4.96875M2.15625 17.7188V23.3438M2.15625 20.5312H12M7.07812 0.75L0.75 4.96875H13.4062L7.07812 0.75ZM7.07812 7.82812C5.91314 7.82812 4.96875 8.77252 4.96875 9.9375C4.96875 11.1025 5.91314 12.0469 7.07812 12.0469C8.24311 12.0469 9.1875 11.1025 9.1875 9.9375C9.1875 8.77252 8.24311 7.82812 7.07812 7.82812Z"
            stroke="#d46b08"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Tag>
    </Tooltip>
  );
};

export default BigToyIcon;
